export const API_URL = process.env.NODE_ENV === 'development' ?
    `http://${window.location.hostname}:3020` : process.env.REACT_APP_API_URL;